module.exports = __webpack_public_path__ + "img/hysh.434ec6c9.jpg";